import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Header } from 'foundations-components/transitional/components/Header';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PerformanceEmptyState = ({
  contentStatus = 'default'
}) => {
  return /*#__PURE__*/_jsx(TFlex, {
    align: "center",
    "data-test-id": "performance-empty-state",
    direction: "row",
    justify: "between",
    children: /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      direction: "column",
      justify: "center",
      children: [/*#__PURE__*/_jsx(Illustration, {
        name: contentStatus === 'draft' ? 'pencil' : 'success',
        width: "15%",
        paddingBlockStart: "400"
      }), /*#__PURE__*/_jsx(Header, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `page-details-ui.reporting.performanceEmptyState.title.${contentStatus}`
        }),
        use: "condensed",
        padding: "300"
      }), /*#__PURE__*/_jsx(View, {
        maxInlineSize: "450px",
        children: /*#__PURE__*/_jsx(Text, {
          textAlign: "center",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `page-details-ui.reporting.performanceEmptyState.message.${contentStatus}`
          })
        })
      })]
    })
  });
};
export default PerformanceEmptyState;